export const handleSetInstance = (id, data, setData) => {
  const instance = data.users.filter(item => (item._id === id))
  setData(instance[0])
}